import { Navigate, Route, Routes } from 'react-router-dom'
import { lazy } from 'react'
import { SuspenseWithFallback } from 'shared/ui'
import {
  ChatbotAnalyticRouter,
  ChatbotEditPage,
  ChatbotListPage,
  ChatbotNewPage,
} from 'pages/chatbot/pages'
import { ChatbotLayout, ListLayout } from 'pages/chatbot/layout'
import { ChatbotAccessLayout } from 'pages/chatbot/layout/ChatbotAccessLayout'
import { AgentBookAppointmentStepsRouter } from 'pages/chatbot/pages/agentBookAppointment'
import { Texting } from 'pages/chatbot/pages/texting/Texting'
import { Calling } from 'pages/chatbot/pages/calling'
import { AiCallingAccessLayout } from 'pages/chatbot/layout/AiCallingAccessLayout'
import { ViewCalling } from 'pages/chatbot/pages/calling/pages/view/ViewCalling'
import { ChatbotRoutes } from './type'

const EditCalling = lazy(() => import('pages/chatbot/pages/calling/pages/edit/EditCalling'))
const NewCalling = lazy(() => import('pages/chatbot/pages/calling/pages/new/NewCalling'))

export const ChatbotRouter = () => {
  return (
    <Routes>
      <Route element={<ChatbotAccessLayout />}>
        <Route element={<ChatbotLayout />}>
          <Route index element={<Navigate to={ChatbotRoutes.texting} />} />
          <Route path={`${ChatbotRoutes.all}`} element={<ChatbotListPage />} />
          <Route element={<AiCallingAccessLayout />}>
            <Route element={<ListLayout />}>
              <Route path={ChatbotRoutes.texting} element={<Texting />} />
              <Route path={ChatbotRoutes.calling} element={<Calling />} />
            </Route>
          </Route>

          <Route element={<AiCallingAccessLayout />}>
            <Route
              path={`${ChatbotRoutes.calling}/${ChatbotRoutes.new}`}
              element={
                <SuspenseWithFallback>
                  <NewCalling />
                </SuspenseWithFallback>
              }
            />
            <Route
              path={`${ChatbotRoutes.calling}/${ChatbotRoutes.edit}/:id`}
              element={
                <SuspenseWithFallback>
                  <EditCalling />
                </SuspenseWithFallback>
              }
            />
            <Route
              path={`${ChatbotRoutes.calling}/${ChatbotRoutes.view}/:id`}
              element={<ViewCalling />}
            />
          </Route>

          <Route
            path={`/:agentId/${ChatbotRoutes.steps}/*`}
            element={<AgentBookAppointmentStepsRouter />}
          />
          <Route
            path={`/${ChatbotRoutes.new}/${ChatbotRoutes.steps}/*`}
            element={<AgentBookAppointmentStepsRouter />}
          />
          <Route path={`${ChatbotRoutes.new}`} element={<ChatbotNewPage />} />
          <Route path=':agentId' element={<ChatbotEditPage />} />
          <Route path={`:agentId/${ChatbotRoutes.analytic}`} element={<ChatbotAnalyticRouter />} />
          <Route path='*' element={<div>Page Not Found</div>} />
        </Route>
      </Route>
    </Routes>
  )
}
